import { useState, useEffect } from "react";
import { ExpandedContent, Separator } from "../../Compartilhado/styles";
import { IItemHistorico } from "../../../../types";
import { DadosPendenciaAceita } from "./types";
import { processarDadosPendenciaAceita } from "./utils";
import BlocoPrincipal from "./Blocos/BlocoPrincipal/index";
import BlocoAnexos from "../../Compartilhado/Blocos/BlocoAnexos";
import BlocoEmail from "../DemandaCriada/Blocos/BlocoEmail/index";
import LogsVazio from "../../Compartilhado/LogsVazio";
import api from "../../../../../../../services/api";

// ExpandedContent component for PendenciaAceita card

interface ExpandedContentProps {
    item: IItemHistorico;
    onNavigateToFile?: (fileId: number) => void;
}

export default function ExpandedContentPendenciaAceita({ item, onNavigateToFile }: ExpandedContentProps) {
    const [dados, setDados] = useState<DadosPendenciaAceita | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!item.id) {
            setLoading(false);
            return;
        }

        const buscarDados = async () => {
            try {
                setLoading(true);
                const response = await api.get(`log-historico/${item.id}`);

                if (response.data.status === 'success') {
                    const logs = response.data.result || [];
                    const dadosProcessados = processarDadosPendenciaAceita(logs);
                    setDados(dadosProcessados);
                } else {
                    setDados({
                        campos: [],
                        anexos: [],
                        email: null
                    });
                }
            } catch (error: any) {
                setDados({
                    campos: [],
                    anexos: [],
                    email: null
                });
            } finally {
                setLoading(false);
            }
        };

        buscarDados();
    }, [item.id]);

    if (loading) {
        return (
            <ExpandedContent>
                <div style={{ padding: '20px', textAlign: 'center', color: 'var(--c64748b)' }}>
                    Carregando dados...
                </div>
            </ExpandedContent>
        );
    }

    if (!dados) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    const temDadosValidos = dados.campos.length > 0 || dados.anexos.length > 0 || dados.email !== null;

    if (!temDadosValidos) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    return (
        <ExpandedContent>
            <Separator />
            {dados.campos.length > 0 && <BlocoPrincipal campos={dados.campos} idPendencia={dados.idPendencia} />}
            {dados.anexos.length > 0 && <BlocoAnexos anexos={dados.anexos} onNavigateToFile={onNavigateToFile} />}
            {dados.email && <BlocoEmail email={dados.email} />}
        </ExpandedContent>
    );
}
